// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__R60ve","title":"style_title__FuoQ6","list":"style_list__IP56v","card":"style_card__jglHx","mobileLayout":"style_mobileLayout__ssc0T"};